export enum ChatStatusEnum {
  ACTIVE = 'Active',
  DELETED = 'Deleted',
  ARCHIVED = 'Archived',
}
